export const elementNames = {
    firstName: 'firstName',
    lastName: 'lastName',
    birthDay: 'birthDay',
    birthMonth: 'birthMonth',
    birthYear: 'birthYear',
    sex: 'sex',
};

export const elementMetricNames = {
    [elementNames.firstName]: 'First name',
    [elementNames.lastName]: 'Last name',
    [elementNames.birthDay]: 'Birth day',
    [elementNames.birthMonth]: 'Birth month',
    [elementNames.birthYear]: 'Birth year',
    [elementNames.sex]: 'Sex',
};

export const componentNames = {
    [elementNames.firstName]: 'Name',
    [elementNames.lastName]: 'Name',
    [elementNames.birthDay]: 'Birth date',
    [elementNames.birthMonth]: 'Birth date',
    [elementNames.birthYear]: 'Birth date',
    [elementNames.sex]: 'Sex',
};

export const errorNames = {
    nameError: 'nameError',
    birthDateError: 'birthDateError',
    tooYoungError: 'tooYoungError',
    sexError: 'sexError',
};
